
export const name = "email-management-ui";
export const version = "dev";
